export const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:8080/api'
    : 'https://app-5a018d47-0af1-41dd-831e-ba2c5a2b3ced.cleverapps.io/api';
